<script>
import mimeTypes from '../variables/mimeTypes';
import fileTypes from '../variables/fileTypes';

export default {
  props: {
    multiple: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    fileType: {
      type: String,
      default: fileTypes.IMAGE,
      validator: val => [
        fileTypes.IMAGE,
        fileTypes.FILE,
        fileTypes.DOC,
      ].includes(val),
    },
  },
  data() {
    return {
      previews: [],
      files: [],
      fileTypes,
      mimeTypes,
    };
  },
  methods: {
    upload(event) {
      Array.from(event.target.files).forEach((file) => {
        const fileUrl = URL.createObjectURL(file);
        this.previews.push(fileUrl);
        this.files.push(file);
      });
      this.$emit('upload', this.files);
    },
    clear() {
      this.previews = [];
      this.files = [];
    },
    uppercase(str) {
      return str.toUpperCase();
    },
  },
  watch: {
    loading(val) {
      if (!val) {
        this.clear();
      }
    },
  },
};
</script>

<template>
  <v-layout>
    <v-flex xs12>
      <v-layout>
        <v-flex class="xs12 text-xs-center text-sm-center text-md-center text-lg-center">
          <div class="tw-file-upload-wrapper">
            <div
              v-if="previews.length"
              class="tw-file-upload-preview-wrapper"
            >
              <div class="tw-file-upload-preview"
                   v-for="(image, index) in previews"
                   :key="`tw-file-upload-image-${index}`"
                   :class="{'tw-file-upload-preview--MULTIPLE': multiple}">
                <img
                  :src="image"
                  class="tw-file-upload-preview-image"
                />
              </div>
              <div v-if="loading" class="tw-file-upload-input-text">
                <v-progress-circular
                  :size="50"
                  color="primary"
                  indeterminate
                />
              </div>
            </div>
            <div
              v-else
              class="tw-file-upload-body"
            >
              <input
                id="tw-file-upload-input"
                :accept="mimeTypes[uppercase(fileType)]"
                :multiple="multiple"
                :disabled="loading"
                class="tw-file-upload-input"
                type="file"
                ref="file"
                @change="upload"
              />
              <div class="tw-file-upload-input-text">
                <v-icon>cloud_upload</v-icon>
                <span
                  v-if="fileType === fileTypes.IMAGE"
                  v-html="$t('imageUpload.body.upload')"
                />
                <span
                  v-else-if="fileType === fileTypes.FILE"
                  v-html="$t('imageUpload.body.uploadFile')"
                />
                <span
                  v-else-if="fileType === fileTypes.DOC"
                  v-html="$t('imageUpload.body.uploadDocument')"
                />
              </div>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<style lang="scss">
  @import '../assets/scss/variables.scss';
  @import "../assets/scss/mixins";

  .tw-file-upload-wrapper {
    position: relative;
    width: calc(100% - #{$margin-lg * 2});
    height: $tw-file-input-height + $margin-lg;
    margin: $margin-lg $margin-lg 0;
    border: 3px dotted $brand-grey-lighter;
  }

  .tw-file-upload-icon {
    width: 100%;
    height: $tw-file-input-height;
  }

  .tw-file-upload-input {
    @include position-absolute();
    width: 100%;
    height: $tw-file-input-height + $margin-lg;
    opacity: 0;
    cursor: pointer;
  }

  .tw-file-upload-preview {
    @include position-absolute();
    width: calc(100% - #{$margin-lg * 2});
    height: $tw-file-input-height - $margin-lg;
    transition: .2s all ease;
    overflow: hidden;

    &--MULTIPLE {
      position: relative;
      width: calc((100% - #{$margin-lg * 2}) / 5);
      height: calc((#{$tw-file-input-height} - #{$margin-lg}) / 2);
      float: left;
    }
  }

  .tw-file-upload-preview-image {
    opacity: .4;
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  .tw-file-upload-input-text {
    @include position-absolute();
    width: 100%;
    height: $tw-file-input-height;
    line-height: $tw-file-input-height;
    user-select: none;
    pointer-events: none;
  }

  .tw-file-upload-label input[type="text"]{
    cursor: default;
  }
</style>



// WEBPACK FOOTER //
// src/components/TwFileUpload.vue